import { render, staticRenderFns } from "./orders-and-deliveries.vue?vue&type=template&id=2b33f758&scoped=true"
import script from "./orders-and-deliveries.vue?vue&type=script&lang=js"
export * from "./orders-and-deliveries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b33f758",
  null
  
)

export default component.exports